import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesVentas() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "Ventas", items: [
      { label: "Cotizaciones", icon: "fas fa-file-invoice-dollar", color: "#2563eb", href: "/ListadoCotizaciones", enabled: !!(user.menu_ventas && user.menu_pedidos) },
      { label: "Pedidos", icon: "fas fa-shopping-basket", color: "#2563eb", href: "/ListadoPedidos", enabled: !!(user.menu_ventas && user.menu_pedidos) },
      { label: "Seguimiento Pedidos", icon: "fas fa-chart-line", color: "#2563eb", href: "/SeguimientoPedidos", enabled: !!(user.menu_ventas && user.menu_pedidos) },
      { label: "Entregar", icon: "fas fa-truck-moving", color: "#2563eb", href: "/ListadoPendienteSurtir", enabled: !!(user.menu_ventas && user.menu_surtidos) },
      { label: "Venta Directa", icon: "fas fa-bolt", color: "#2563eb", href: "/VentaDirectaCreate", enabled: !!(user.menu_ventas && user.menu_pedidos) },
      { label: "Ventas", icon: "fas fa-money-bill-wave", color: "#2563eb", href: "/ListadoVentas", enabled: !!(user.menu_ventas && (user.menu_admin || user.menu_surtidos)) },
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#2563eb", href: "/ListadoDevoluciones", enabled: !!(user.menu_ventas && user.menu_devoluciones) },
    ]},
    { section: "Reportes", items: [
      { label: "Reporte Cotizaciones", icon: "fas fa-chart-pie", color: "#7c3aed", href: "/ReporteCotizaciones", enabled: !!(user.menu_ventas && user.menu_pedidos) },
      { label: "Reporte Cotizaciones Vendedor", icon: "fas fa-user-tag", color: "#7c3aed", href: "/ReporteCotizacionesVendedor", enabled: !!(user.menu_ventas && user.menu_pedidos) },
      { label: "Reporte Estatus Pedidos", icon: "fas fa-tasks", color: "#7c3aed", href: "/ReporteEstatusPedidos", enabled: !!(user.menu_ventas && user.menu_pedidos) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Pedidos"
      descripcion="Cotizaciones, pedidos y ventas"
      icono="fas fa-shopping-basket"
      color="#2563eb"
      secciones={secciones}
    />
  );
}

export default BotonesVentas;
